<carrusel-generico-view *ngIf="!isSearching"></carrusel-generico-view>
<category-scroll-filter *ngIf="!isSearching && !ocultarCarrouselCategorias"></category-scroll-filter>
<section *ngIf="verTutoriales && !isSearching">
  <mmax-tutoriales></mmax-tutoriales>
</section>
<div class="home-section" *ngIf="articulosEnPromociones.length !== 0 && !isSearching">
  <mmax-landpage-frame [nombre]="'PROMOCIONES'"></mmax-landpage-frame>
  <section>
    <div>
      <div class="articulosss">
        <lista-productos-view [articulosIn]="articulosEnPromociones" [modelo]="'promos-land'"></lista-productos-view>
      </div>
    </div>
  </section>
</div>

<div class="home-section" *ngIf="articulosEnOfertas.length !== 0">
  <mmax-landpage-frame [nombre]="'OFERTAS'"></mmax-landpage-frame>
  <section>
    <div>
      <div class="articulosss">
        <lista-productos-view [articulosIn]="articulosEnOfertas" [modelo]="'ofertas-land'"></lista-productos-view>
      </div>
    </div>
  </section>
</div>

<div class="home-section" *ngIf="hayMarcas">
  <mmax-landpage-frame [nombre]="'Marcas destacadas'"></mmax-landpage-frame>
  <section>
    <app-marcas-destmmax [mode]="'pc-land'"></app-marcas-destmmax>
  </section>
</div>

<div class="home-section" *ngIf="loading || articulosDestacados.length !== 0">
  <mmax-landpage-frame [nombre]="'PRODUCTOS DESTACADOS'"></mmax-landpage-frame>
  <section>
    <div>
      <div class="articulosss">
        <lista-productos-view [articulosIn]="articulosDestacados" [modelo]="'destacados-land'" [loading]="loading"></lista-productos-view>
      </div>
    </div>
  </section>
</div>


<mmax-helpfootbar></mmax-helpfootbar>
<foo-mariano-max></foo-mariano-max>